// Карточка «Быстрые действия» в правой колонке ЛК.
// primary: золотая filled-кнопка (купить ещё билет).
// secondary: outline-кнопки со стрелкой.
export const accountActionsSection = {
  title: 'Быстрые действия',
  links: [
    { label: 'Открыть программу', href: '/#program', tone: 'secondary' },
    { label: 'Посмотреть спикеров', href: '/#experts', tone: 'secondary' },
    { label: 'Купить ещё билет', href: '/tariff', tone: 'primary' }
  ]
};
